import SignUpForm from "./organisms/o-sign-up-form";
import SignUpInfo from "./organisms/o-sign-up-info";
import SignUpPage from "./pages/p-sign-up";
import SignUp from "./services/sign-up.repository";
import routing from "./sign-up.routes";
import SignUpComponent from "./sign-up.component";

export default angular.module('app.sign-up', [])
    .config(routing)
    .component('pSignUp', new SignUpPage)
    .component('oSignUpForm', new SignUpForm)
    .component('oSignUpInfo', new SignUpInfo)
    .component('signUp', new SignUpComponent)
    .service('SignUp', SignUp)
    .name;

